import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {parse} from 'query-string';
import {withRouter} from 'react-router-dom';

import {appConfigService} from '_app/services';
import './share-control.less';
import {Enums, mergeClasses, sectionConstants} from '_app/utils';
import {fileTypeService, linkService} from '_app/services';
import MediaHubActions from '_app/shared/actions/MediaHubActions';
import {fetchFavoriteCampaignTemplates} from '_app/mediahub/scenes/Campaigns/LeadGeneration-Nurturing/leadGenerationNurturingActions';
import SharePopover from '_app/shared/features/SharePopover';
import {getPrevPageTitle} from '_app/mediahub/mediaHubUtils';
import {ComplianceDownloadControl} from './ComplianceDownloadControl';
import {getProxiedAs} from '_app/shared/features/users/proxiedAs/proxiedAsSelectors';

export class ShareControl extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isFavorite: this.props.media.IsFavorite
		};

		this.onEmailShare = this.onEmailShare.bind(this);
		this.handleFavorite = this.handleFavorite.bind(this);
	}

	downloadControl() {
		// TODO: downloadlink on media, logic should be moved to frontend
		let downloadUrl = null;
		let link = null;

		if (this.props.downloadUrl) {
			link = (
				<a href={this.props.downloadUrl} download className="fa fa-download fa-1 media-share-icon undecorated">
					<span className="media-share-icon-title">Download</span>
				</a>
			);
		} else if (this.props.media.SourceContentUrl) {
			downloadUrl = decodeURIComponent(this.props.media.SourceContentUrl);
			link = (
				<a href={downloadUrl} download target="_blank" className="fa fa-download fa-1 media-share-icon undecorated">
					<span className="media-share-icon-title">Download</span>
				</a>
			);
		} else {
			downloadUrl = fileTypeService.mediaDownloadUrl(this.props.media);
			link = (
				<a href={downloadUrl} download className="fa fa-download fa-1 media-share-icon undecorated">
					<span className="media-share-icon-title">Download</span>
				</a>
			);
		}
		return (
			<div className="share-control-option-container">
				{link}
			</div>
		);
	}

	favoriteControl() {
		return (
			<div className="share-control-option-container">
				<div onClick={this.handleFavorite}
					className={this.state.isFavorite ?
						'fa fa-star fa-1 media-share-icon is-favorite' :
						'fa fa-star-o fa-1 media-share-icon is-favorite'
					}
				>
					<span className="media-share-icon-title">Favorite</span>
				</div>
			</div>
		);
	}

	emailShare() {
		return (
			<div className="share-control-option-container">
				<div onClick={this.onEmailShare} className="fa fa-envelope-o media-share-icon">
					<span className="media-share-icon-title">Start Email</span>
				</div>
			</div>
		);
	}

	canShare() {
		const mediaTypes = Enums.getType('mediaTypes');

		return ((this.props.media.Type !== mediaTypes.EMAIL) &&
				(this.props.media.Type !== mediaTypes.AUDIO) &&
				(this.props.media.Type !== mediaTypes.PRESENTATION)) &&
				this.props.media.ShareSettings &&
				((appConfigService.get('allowSocial') && this.props.media.ShareSettings.SocialShare) ||
				(appConfigService.get('allowEmail') && this.props.media.ShareSettings.EmailShare) ||
				(this.props.media.ShareSettings.LinkShare) ||
				(this.props.media.Type === mediaTypes.VIDEO && this.props.media.ShareSettings.EmbedShare));
	}

	handleFavorite() {
		const fav = !this.state.isFavorite;
		const {itemFavorite, media, refreshFavorites, proxiedAsId} = this.props;
		const {filter} = parse(this.props.location.search);
		const selectedFilter = filter ? filter : 0;

		this.setState({
			isFavorite: fav
		});

		if (media.Section === 1 ) {
			this.props.getFavoriteTemplates(media.ID, fav, selectedFilter, proxiedAsId);
		} else {
			itemFavorite(media.ID, fav, refreshFavorites, selectedFilter, proxiedAsId);
		}
	}

	onEmailShare() {
		window.location.href = `${linkService.go(this.props.media)}?prevPage=${getPrevPageTitle(this.props.location.pathname)}`; //TODO: history.push should be used
	}

	render() {
		const {media, isFavorite, hideFavorite, showShareControl, includeCompliance} = this.props;
		const complianceItems = [];
		const section = media.Section;
		const includeShare = showShareControl && this.canShare();
		const includeEmail = (section === sectionConstants.SECTION_IDS.EMAILS_ID);
		const includeFavorite = (!hideFavorite && ((section !== sectionConstants.SECTION_IDS.CAMPAIGNS_ID) || (isFavorite !== undefined)));
		const includeDownload = this.props.download;
		const containerClassName = mergeClasses(
			'share-control-container',
			this.props.detail && 'is-detailed'
		);

		if (includeCompliance && media.SupportItems) {
			const complianceVideo = media.SupportItems.find( items => items.Type === Enums.getType('fileTypes').COMPLIANCE_VIDEO);
			const storyboard = media.SupportItems.find(items => items.Type === Enums.getType('fileTypes').STORYBOARD);

			if (complianceVideo) {
				complianceItems.push(complianceVideo);
			}
			if (storyboard) {
				complianceItems.push(storyboard);
			}
		}

		return (
			<div className={containerClassName}>
				{includeShare && <SharePopover media={media} containerClassName="share-control-option-container" />}
				{includeEmail && this.emailShare()}
				{includeFavorite && this.favoriteControl()}
				{includeDownload && this.downloadControl()}
				{includeCompliance && complianceItems.map(item =>
					<ComplianceDownloadControl
						id={item.ID}
						type={item.Type}
						mediaName={media.Name}
					/>)}
			</div>
		);
	}
}
ShareControl.defaultProps = {
	media: [],
	hideFavorite: false
};

ShareControl.defaultProps = {
	media: [],
	hideFavorite: false,
	showShareControl: true,
	downloadUrl: null
};

ShareControl.propTypes = {
	media: PropTypes.object.isRequired,
	download: PropTypes.bool.isRequired,
	detail: PropTypes.bool.isRequired,
	// functions
	itemFavorite: PropTypes.func.isRequired,
	refreshFavorites: PropTypes.bool,
	hideFavorite: PropTypes.bool,
	showShareControl: PropTypes.bool,
	includeCompliance: PropTypes.bool,
	downloadUrl: PropTypes.string
};

const mapDispatchToProps = {
	itemFavorite: MediaHubActions.itemFavorite,//should be moved to features in scope of media feature movement
	getFavoriteTemplates: fetchFavoriteCampaignTemplates
};

const mapStateToProps = (state) => {
	return {
		proxiedAsId: getProxiedAs(state)?.userID
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareControl));